import { SET_DRUG_RULES_SETTINGS_BY_USER_ID } from './drugRulesSettingsConstants'

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const setDrugRulesSettingsByUserId = ({ patientId, patientHomeAddressState }) => ({
  type: SET_DRUG_RULES_SETTINGS_BY_USER_ID,
  payload: { patientId, patientHomeAddressState },
})
